const EventType = {
  TFA: 'tfa',
  PASSCODE: 'passcode',
  EMAIL_VERIFY: 'email_verify',
  PHONE_VERIFY: 'phone_verify',
  PASSWORD_RESET: 'password_reset',
  PIN_RESET: 'pin_reset',
  ADD_USER: 'add',
  DEMOTE_USER: 'demote',
  GROUP_VALIDATION: 'Group already exists with this name',
  ADMIN: 'moderator',
};

export default {
  EventType,
};
